
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";


import AboutImg from "../assets/2.jpg";

function Contact(params) {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        heroImg={AboutImg}
        title="Contact"
        url="/contact"
        
        btnClass="hide"
      />
      <ContactUs/>
      <Footer/>
    </>
  );
}

export default Contact;
